import { GoldErrorBoundaries } from "@ibcos/ui-components/dist/components/GoldErrorBoundaries/GoldErrorBoundaries";
import { useLogger } from "@ibcos/ui-components/dist/components/Hooks/UseLogger/useLogger";
import { ErrorInfo } from "react";

import ErrorFallback from "./ErrorFallback";
import { FallbackProps } from "react-error-boundary";

const GoldErrorBoundaryWrapper: React.FC<{
    children?: React.ReactNode;
    passedError?: Error | null;
}> = ({ children, passedError }) => {
    const { logError } = useLogger();

    const handleError = (error: unknown, info: ErrorInfo) => {
        if (error instanceof Error) {
            logError(
                `${error.message} | Component Stack: ${info.componentStack}`,
                error,
            );
        }
    };

    const ThrowErrorComponent: React.FC = () => {
        throw Error();
    };

    const FallbackWrapper = (props: FallbackProps) => (
        <ErrorFallback {...props} error={passedError} />
    );

    return (
        <GoldErrorBoundaries
            FallbackComponent={FallbackWrapper}
            onError={handleError}
        >
            {children ?? <ThrowErrorComponent />}
        </GoldErrorBoundaries>
    );
};

export default GoldErrorBoundaryWrapper;
